import { Injectable, OnInit } from '@angular/core';
import { Toast } from 'bootstrap';

@Injectable({
  providedIn: 'root',
})
export class ToastService implements OnInit {
  private toastElement: any;

  constructor() {
    setTimeout(() => {
      this.toastElement = document.getElementById('liveToast');
    }, 0);
  }

  ngOnInit(): void {
  }

  showSuccess(message: string) {
    this.toastElement.classList.remove(`text-bg-danger`);
    if (message == 'successful') {
      message = 'Request successful'
    }
    this.showToast('Success', message, 'success');
  }

  showError(message: string) {
    this.toastElement.classList.remove(`text-bg-success`);
    this.showToast("Error", message, 'danger');
  }

  showToast(title: string, message: string, type: string) {
    if (this.toastElement) {
      this.toastElement.classList.add(`text-bg-${type}`);
      this.toastElement.querySelector('.toast-header strong').innerText = title;
      this.toastElement.querySelector('.toast-body').innerText = message;
      this.toastElement.classList.add(`text-bg-${type}`);
      const toast = new Toast(this.toastElement);
      toast.show();
    }
  }
}
